/* ============================================
   NODUS 11 · CLOSING
   Lets the closing call-to-action reuse the Nodus product form instead of
   posting its own cart request, so quantity, variant and add-ons stay in sync.
   ============================================ */

if (!customElements.get('nodus-closing-cta')) {
	class NodusClosingCta extends HTMLElement {
		connectedCallback() {
			this.button = this.querySelector('[data-nodus-closing-add]');

			if (!this.button) return;

			this.handleClick = this.onClick.bind(this);
			this.button.addEventListener('click', this.handleClick);
		}

		disconnectedCallback() {
			if (this.button && this.handleClick) {
				this.button.removeEventListener('click', this.handleClick);
			}
		}

		get productSubmit() {
			return document.querySelector('nodus-product-form [data-nodus-submit]');
		}

		onClick() {
			const submit = this.productSubmit;

			if (!submit) {
				window.location.href = this.dataset.fallbackUrl;
				return;
			}

			if (submit.disabled) {
				submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
				return;
			}

			submit.click();
		}
	}

	customElements.define('nodus-closing-cta', NodusClosingCta);
}
